import React from 'react';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import UserMenuView from './UserMenuView';
import {getTermsAndConditionsPath, getPrivacyPolicyPath, getTermsOfUsePath} from '../../../../utils/path';
import authenticationService from '../../../../services/authentication/AuthenticationService';

function UserMenuContainer() {
  const currentLocale = useSelector(state => state.i18n.locale);
  const history = useHistory();
  const [isUserMenuOpen, setIsUserMenuOpen] = React.useState(false);

  function handleOpenTermsAndConditions() {
    window.open(getTermsAndConditionsPath(currentLocale));
  }

  function handleOpenPrivacyPolicy() {
    window.open(getPrivacyPolicyPath(currentLocale));
  }

  function handleOpenTermsOfUse() {
    window.open(getTermsOfUsePath(currentLocale));
  }

  function handleLogout() {
    authenticationService.logout();
  }

  return (
    <>
      <UserMenuView
        onUserSettingsSelect={() => history.push('/account')}
        onOpenTermsAndConditions={handleOpenTermsAndConditions}
        onOpenPrivacyPolicy={handleOpenPrivacyPolicy}
        onOpenTermsOfUse={handleOpenTermsOfUse}
        onLogout={handleLogout}
        onSwitchUserMenu={() => setIsUserMenuOpen(isOpen => !isOpen)}
        isUserMenuOpen={isUserMenuOpen}
      />
    </>
  );
}

export default UserMenuContainer;
